// <gallery-metafield-video> — autoplays (muted) the metafield YouTube video
// when its gallery slide is the active/visible one, and pauses it otherwise.
if (!customElements.get('gallery-metafield-video')) {
  class GalleryMetafieldVideo extends HTMLElement {
    connectedCallback() {
      this.template = this.querySelector('template');
      this.poster = this.querySelector('.media-poster');
      this.loaded = false;
      this.iframe = null;

      if (this.poster) {
        this.poster.addEventListener('click', () => this.play());
      }

      if ('IntersectionObserver' in window) {
        const viewer = this.closest('.media-viewer');
        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.intersectionRatio >= 0.7) {
              this.play();
            } else {
              this.pause();
            }
          });
        }, { root: viewer, threshold: [0, 0.7] });
        this.observer.observe(this);
      }
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    loadIframe() {
      if (this.loaded || !this.template) return;
      const content = this.template.content.firstElementChild.cloneNode(true);
      this.appendChild(content);
      this.iframe = content;
      this.loaded = true;
      if (this.poster) this.poster.hidden = true;
    }

    play() {
      if (!this.loaded) {
        // The iframe URL carries autoplay=1&mute=1, so it starts on load.
        this.loadIframe();
        return;
      }
      this.postToFrame('playVideo');
    }

    pause() {
      if (this.loaded) this.postToFrame('pauseVideo');
    }

    postToFrame(func) {
      if (!this.iframe || !this.iframe.contentWindow) return;
      this.iframe.contentWindow.postMessage(
        JSON.stringify({ event: 'command', func, args: '' }), '*'
      );
    }
  }

  customElements.define('gallery-metafield-video', GalleryMetafieldVideo);
}
